"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const discountInputs = [
  {
    name: "welcomeTitle",
    type: "string",
    defaultValue: "Get an exclusivein-store discount",
  },
  {
    name: "welcomeSubHeadline",
    type: "string",
    defaultValue: "Context title",
  },
  {
    name: "welcomeText",
    type: "richText",
    defaultValue:
      "We re thrilled to offer you an exclusive discount at our partner stores, takes advantage of an amazing X% discount on your purchase. Get your discount here, check your email and don t forget to present it to the sales assistant when you shop in any of our partner store",
  },
  {
    name: "successTitle",
    type: "string",
    defaultValue: "Congratulations!",
  },
  {
    name: "successText",
    type: "string",
    defaultValue:
      "Your discount code has been sent. Check your email for more details.",
  },
  {
    name: "successButtonLabel",
    type: "string",
    defaultValue: "Return to homepage",
  },
  {
    name: "successButtonUrl",
    type: "string",
    defaultValue: "/",
  },
  {
    name: "requestLimitErrorPageTitle",
    type: "string",
    defaultValue: "Voucher limit reached",
  },
  {
    name: "requestLimitErrorPageText",
    type: "richText",
    defaultValue:
      "Oops! It looks like you’ve reached the maximum limit for requesting vouchers. If you have any questions or need assistance, feel free to contact our support team. Thank you!",
  },
  {
    name: "requestLimitErrorPageButtonLabel",
    type: "string",
    defaultValue: "Return to homepage",
  },
  {
    name: "requestLimitErrorPageButtonUrl",
    type: "string",
    defaultValue: "/",
  },
  {
    name: "buttonLabel",
    type: "string",
    defaultValue: "Get your discount",
  },
  {
    name: "imageFileReference",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fda570d986cfd484082ec3685c648268f",
  },
  {
    name: "imageSmallFileReference",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fda570d986cfd484082ec3685c648268f",
  },
  {
    name: "backgroundImageFileReference",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F1331ac9131874954bf752e02aa5ef009",
  },
  {
    name: "backgroundImageSmallFileReference",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F1331ac9131874954bf752e02aa5ef009",
  },
] as const satisfies Inputs;

export const DiscountComponent: RegisteredComponent = {
  name: "Discount",
  component: dynamic(async () =>
    withValidation(
      discountInputs,
      (await import("./Discount")).Discount,
      "Discount"
    )
  ),
  inputs: discountInputs,
};
